






































































import Vue from 'vue';
import VatsAPI from '@/Shared/VatsAPI';
import { ReportName } from './ReportName';
import LocationBasedMixin from '@/Shared/LocationBasedMixin';
import mixins from 'vue-typed-mixins';

const NotificationsAdmin = mixins(LocationBasedMixin).extend({
    props: ['location'],
    data() {
        return {
            validationErrors: {} as { [key: string]: string[] },
            reports: [] as ReportName[],
            categories: [] as string[],
            selectedCategory: null as string | null,
            selectedReport: null as ReportName | null,
            startDate: null as Date | null,
            endDate: null as Date | null,
            selectedReportType: 'Excel',
            options: [
                { text: 'HTML', value: 'HTML' },
                { text: 'Excel', value: 'Excel' },
                { text: 'PDF', value: 'PDF' }
            ]
        };
    },
    methods: {
        async categoryChanged() {
            this.reports = await this.getSelectedCategory();
        },
        async getReportNames() {
            const axiosResponse = await VatsAPI.get<ReportName[]>(`/ReportingGenerator/ReportNames`);
            return axiosResponse.data;
        },

        async getReportCategories() {
            const axiosResponse = await VatsAPI.get<string[]>(`/ReportingGenerator/ReportCategories`);
            return axiosResponse.data;
        },
        async getSelectedCategory() {
            const url = `/ReportingGenerator/GetSelectedCategory?category=${this.selectedCategory}`;
            const axiosResponse = await VatsAPI.get<ReportName[]>(url);
            return axiosResponse.data;
        },
        async runReport() {
            let vurl = ``;
            if (((window.location.hostname).indexOf('localhost') > -1)
                || (window.location.hostname).indexOf('development') > -1) {
                vurl = `https://development.municipalcitationsolutions.com`;
            }
            const url = vurl + `${this.selectedReport?.reportPage}`.replace('..', '');
            const startDate = encodeURIComponent(this.startDate?.toISOString().substr(0, 10) || '');
            const endDate = encodeURIComponent(this.endDate?.toISOString().substr(0, 10) || '');
            if (this.selectedCategory == null) {
                Vue.set(this.validationErrors, 'selectedCategory', ['Please select a category']);
            }
            else {
                Vue.delete(this.validationErrors, 'selectedCategory');
            }
            if (this.selectedReport?.reportName == null) {
                Vue.set(this.validationErrors, 'selectedReport', ['Please select a report']);
            }
            else {
                Vue.delete(this.validationErrors, 'selectedReport');
            }
            if (endDate <= startDate) {
                Vue.set(this.validationErrors, 'startDate', ['End date must be after start date']);
            }
            else {
                Vue.delete(this.validationErrors, 'startDate');
            }
            if (Object.keys(this.validationErrors)) {
                if (this.selectedReportType === 'Excel') {
                    window.location.assign(url + `?p1=${startDate}&p2=${endDate}&p3=${this.selectedReportType}&p4=0`);
                }
                else {
                    window.open(url + `?p1=${startDate}&p2=${endDate}&p3=${this.selectedReportType}&p4=0`, '_blank');
                }
            }
        }
    },
    async mounted() {
        this.reports = await this.getReportNames();
        this.categories = await this.getReportCategories();
    },
});

export default NotificationsAdmin;
